<template>
    <div class="animated fadeIn">

        <Request
                ref="requestOptions"
                :onRequestSuccess="onRequestSuccess"
                root="/shop/options">
            <slot slot="body">
                <b-row :key="productIndex" v-for="product, productIndex in dataProducts" v-if="Core.Product.conditionalIsEnabled(product) || Core.Product.participantModeIsEnabled(product) || productHasFormTemplate(product)">
                    <b-col>
                        <b-card>
                            <div slot="header">
                                <strong>{{Core.Text.format(Core.Definition.getDefinition('{0} #{1}'), product.title, productIndex + 1)}}</strong>
                            </div>

                            <div v-if="Core.Product.conditionalIsEnabled(product)">

                                <b-row>
                                    <b-col lg="6">
                                        <div v-if="Core.Value.encode(product.conditionalForceSeasonId, 'checkbox')">
                                            <InputSelect
                                                    :search="false"
                                                    :label="Core.Definition.getDefinition('Veuillez sélectionner une saison')"
                                                    :options="dataSelectOptions.conditionalSeasonId"
                                                    v-model="product.conditional.seasonId"></InputSelect>
                                        </div>
                                        <div v-if="Core.Value.encode(product.conditionalForceLeagueId, 'checkbox')">
                                            <InputSelect
                                                    :search="false"
                                                    :label="Core.Definition.getDefinition('Veuillez sélectionner une ligue')"
                                                    :options="dataSelectOptions.conditionalLeagueId"
                                                    v-model="product.conditional.leagueId"></InputSelect>
                                        </div>
                                        <div v-if="Core.Value.encode(product.conditionalForceDistrictId, 'checkbox')">
                                            <InputSelect
                                                    :search="false"
                                                    :label="Core.Definition.getDefinition('Veuillez sélectionner une région')"
                                                    :options="dataSelectOptions.conditionalDistrictId"
                                                    v-model="product.conditional.districtId"></InputSelect>
                                        </div>
                                        <div v-if="product.conditional.eventDateId!==null && filterCompleted(product)" :key="productIndex + '-' + conditionalEventDateIndex" v-for="conditionalEventDate, conditionalEventDateIndex in product.conditional.eventDateId">
                                            <b-button @click="onSelectEventDateClick(productIndex, conditionalEventDateIndex)" class="btn btn-sm m-1" :class="{'btn-light' : !Core.Validation.isId(conditionalEventDate.id), 'btn-success' : Core.Validation.isId(conditionalEventDate.id)}">
                                                <span v-if="!Core.Validation.isId(conditionalEventDate.id)">
                                                    {{Core.Text.format(Core.Definition.getDefinition('Sélectionnez un événement #{0}'), conditionalEventDateIndex + 1)}}
                                                </span>
                                                <span v-if="Core.Validation.isId(conditionalEventDate.id)">
                                                    {{ Core.Date.readableDate(conditionalEventDate.start) }} - {{conditionalEventDate.title}}
                                                </span>
                                            </b-button>
                                        </div>
                                        <b-alert v-if="product.verbal!==''" show variant="light">
                                            {{product.verbal}}
                                        </b-alert>
                                    </b-col>
                                </b-row>

                            </div>

                            <div class="mt-4" v-if="Core.Product.participantModeIsEnabled(product)">
                                <b-row class="mb-3">
                                    <b-col>
                                        <strong>{{Core.Definition.getDefinition('Complétez les informations du participant')}}</strong>
                                    </b-col>
                                </b-row>

                                <b-row class="mb-2">
                                    <b-col>
                                        <b-button @click="onSelectParticipantClick(productIndex)" class="btn btn-sm m-1 btn-light">
                                               {{Core.Definition.getDefinition('Sélectionner un participant existant')}}
                                        </b-button>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col lg="4">
                                        <InputText
                                                :label="Core.Definition.getDefinition('Prénom')"
                                                v-model="product.participant.firstname">
                                        </InputText>
                                    </b-col>
                                    <b-col lg="4">
                                        <InputText
                                                :label="Core.Definition.getDefinition('Nom')"
                                                v-model="product.participant.lastname">
                                        </InputText>
                                    </b-col>
                                    <b-col lg="4">
                                        <InputDatePicker
                                                :label="Core.Definition.getDefinition('Date de naissance')"
                                                v-model="product.participant.birthdate">
                                        </InputDatePicker>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col lg="4">
                                        <InputText
                                                :label="Core.Definition.getDefinition('Urgence: Contact')"
                                                v-model="product.participant.urgencyContact">
                                        </InputText>
                                    </b-col>
                                    <b-col lg="4">
                                        <InputPhone
                                                :label="Core.Definition.getDefinition('Urgence: Téléphone')"
                                                v-model="product.participant.urgencyPhone">
                                        </InputPhone>
                                    </b-col>
                                    <b-col lg="4">
                                        <InputText
                                                :label="Core.Definition.getDefinition('Num. assurance maladie')"
                                                v-model="product.participant.insuranceNumber">
                                        </InputText>
                                    </b-col>
                                </b-row>

                                <b-row v-if="Core.Value.encode(product.teamIsEnabled, 'checkbox') || Core.Value.encode(product.participantCategoryIsEnabled, 'checkbox')">
                                    <b-col lg="6" v-if="Core.Value.encode(product.teamIsEnabled, 'checkbox')">
                                        <InputSelect
                                                :search="false"
                                                :label="Core.Definition.getDefinition('Équipe')"
                                                :options="getTeamOptions(product)"
                                                @onSelect="onSelectTeam(productIndex)"
                                                v-model="product.participant.teamId">
                                        </InputSelect>
                                        <InputText
                                                :_isVisible="false"
                                                :ref="'newTeam' + productIndex"
                                                :label="Core.Definition.getDefinition('Nouvelle équipe')"
                                                :description="Core.Definition.getDefinition('Le nom de votre équipe peut être sujet à une vérification.')"
                                                v-model="product.participant.teamTitle">
                                        </InputText>
                                    </b-col>
                                    <b-col lg="6" v-show="Core.Value.encode(product.participantCategoryIsEnabled, 'checkbox')">
                                        <InputSelect
                                                :search="false"
                                                :label="Core.Definition.getDefinition('Catégorie')"
                                                :options="getParticipantCategoryOptions(product)"
                                                v-model="product.participant.participantCategoryId">
                                        </InputSelect>
                                    </b-col>
                                </b-row>

                                <b-row v-if="Core.Value.encode(product.tshirtSizeIsEnabled, 'checkbox')">
                                    <b-col lg="6">
                                        <InputSelect
                                                :search="false"
                                                :label="Core.Definition.getDefinition('T-Shirt: Taille')"
                                                :options="getTshirtSizeOptions(product)"
                                                v-model="product.participant.tshirtSize">
                                        </InputSelect>
                                    </b-col>
                                    <b-col lg="6">
                                        <InputText
                                                v-if="Core.Value.encode(product.tshirtCustomNameIsEnabled, 'checkbox')"
                                                :label="Core.Definition.getDefinition('T-Shirt: Nom personnalisé')"
                                                v-model="product.participant.tshirtCustomName">
                                        </InputText>
                                    </b-col>
                                </b-row>
                            </div>

                            <div class="mt-4" v-if="productHasFormTemplate(product)">
                                <template v-if="dataFormTemplates.length > 0">
                                    <b-row v-for="formTemplate, formTemplateIndex in dataFormTemplates" v-if="formTemplate.productId === product.id">
                                        <b-col>
                                            <CForm :ref="'integratedForm' + formTemplate.formTemplateId" :structure="formTemplate.structure"></CForm>
                                        </b-col>
                                    </b-row>
                                </template>
                            </div>
                        </b-card>

                        <ModalInstanceSelector
                                :caption="Core.Definition.getDefinition('Choix de l\'événement')"
                                :ref="'modalInstanceSelectorEventDate' + productIndex"
                                root="/event-date/list"
                                v-model="dataEventDates"
                                @onAdd="onAddEventDate"
                                :multiple="false"
                                :searchArgs="[
                                        {
                                            key: 'seasonId',
                                            value: filterSeasonId(product),
                                            compare: 'IN'
                                        },
                                        {
                                            key: 'leagueId',
                                            value: filterLeagueId(product),
                                            compare: 'IN'
                                        },
                                        {
                                            key: 'districtId',
                                            value: filterDistrictId(product),
                                            compare: 'IN'
                                        },
                                        {
                                            key: 'start',
                                            value:  Vue.moment().format('YYYY-MM-DD'),
                                            compare: '>'
                                        }
                                ]"
                                :searchFormStructure="{
                                      rows: [
                                            {
                                                cols: [
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'start'
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                     ],
                                     fields: [
                                            {
                                                id: 'start',
                                                type: 'datePicker',
                                                isInline: false,
                                                label: Core.Definition.getDefinition('Date'),
                                                value: null,
                                                onChange: function() {}
                                            }
                                      ]
                                 }"
                                :options="{
                                        pagination: true,
                                        header: true,
                                        responsive: false,
                                        striped: true,
                                        headerStyle: '1',
                                        emptyText: Core.Definition.getDefinition('Aucune date à afficher'),
                                        borderVariant: 'white',
                                        noBody: true
                                 }"
                                :columns="[
                                {
                                    label: Core.Definition.getDefinition('Date'),
                                    key: 'start',
                                    type: 'date',
                                    format: 'DD MMM YYYY HH:mm',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Titre'),
                                    key: 'title',
                                    sortable: true
                                }
                         ]"></ModalInstanceSelector>

                        <ModalInstanceSelector
                                :caption="Core.Definition.getDefinition('Participants')"
                                :ref="'modalInstanceSelectorParticipant' + productIndex"
                                root="/participant/list"
                                v-model="dataParticipants"
                                @onAdd="onAddParticipant"
                                :multiple="false"
                                :searchArgs="[
                                        {
                                            key: 'parentId',
                                            value: Core.Session.AuthUser.id,
                                        }
                                ]"
                                :options="{
                                        pagination: true,
                                        header: true,
                                        responsive: false,
                                        striped: true,
                                        headerStyle: '1',
                                        emptyText: Core.Definition.getDefinition('Aucun participant existant'),
                                        borderVariant: 'white',
                                        noBody: true
                                 }"
                                :columns="[
                                {
                                    label: Core.Definition.getDefinition('Prénom'),
                                    key: 'firstname',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Nom de famille'),
                                    key: 'lastname',
                                    sortable: true
                                }]">
                        </ModalInstanceSelector>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-alert :show="dataAlertMessage !== false" variant="danger">
                            {{dataAlertMessage}}
                        </b-alert>
                    </b-col>
                </b-row>

                <b-row class="text-right">
                    <b-col>
                        <b-button-group class="mt-4">
                            <b-button @click="onContinueShoppingClick" class="btn btn-light">{{Core.Definition.getDefinition('Continuer à magasiner')}}</b-button>
                            <b-button @click="onCheckoutClick" class="btn btn-light">{{Core.Definition.getDefinition('Passer au paiement')}} <i class="fa fa-chevron-right ml-2"></i></b-button>
                        </b-button-group>
                    </b-col>
                </b-row>

            </slot>
        </Request>

    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import InputSelect from '../../../components/InputSelect'
    import InputText from '../../../components/InputText'
    import InputPhone from '../../../components/InputPhone'
    import InputDatePicker from '../../../components/InputDatePicker'
    import InstanceSelector from '../../../components/InstanceSelector'
    import Request from '../../../components/Request'
    import ModalInstanceSelector from '../../../components/ModalInstanceSelector'
    import CForm from '../../../components/CForm'
    export default {
        name: 'ShopOptions',
        components: {
            InputSelect,
            InputText,
            InputDatePicker,
            InstanceSelector,
            Request,
            ModalInstanceSelector,
            InputPhone,
            CForm
        },
        props: {
            productsRedirectType: {
                type: String,
                default: 'router'
            },
            productsRedirectUrl: {
                type: String,
                default: ''
            },
            checkoutRedirectType: {
                type: String,
                default: 'router'
            },
            checkoutRedirectUrl: {
                type: String,
                default: ''
            }
        },
        watch: {

        },
        computed: {
            products() {
                let products = []
                for (let productIndex in Core.Session.Cart.products) {
                    let product = Core.Array.newObject(Core.Session.Cart.products[productIndex])
                    if (Core.Validation.isId(product.formTemplateId) || Core.Product.participantModeIsEnabled(product) || Core.Product.conditionalIsEnabled(product)) {
                        for(let i = 0; i < product.quantity; i++) {

                            product = Core.Array.newObject(product)

                            product.verbal = ''

                            if (Core.Product.conditionalIsEnabled(product)) {
                                if (product.conditionalSeasonId !== '') {
                                    product.conditionalSeasonId = Core.Value.encode(product.conditionalSeasonId, Core.Value.typeMultiSelect)
                                }

                                if (product.conditionalLeagueId !== '') {
                                    product.conditionalLeagueId = Core.Value.encode(product.conditionalLeagueId, Core.Value.typeMultiSelect)
                                }

                                if (product.conditionalDistrictId !== '') {
                                    product.conditionalDistrictId = Core.Value.encode(product.conditionalDistrictId, Core.Value.typeMultiSelect)
                                }

                                product.conditional = {
                                    eventDateId: null,
                                    seasonId: null,
                                    leagueId: null,
                                    districtId: null
                                }

                                if (product.conditionalForceDate) {
                                    if (product.conditionalDateCount !== undefined &&  product.conditionalDateCount !== '' && product.conditionalDateCount > 0) {
                                        product.conditional.eventDateId = []
                                        for(let eventDateIndex = 0; eventDateIndex < product.conditionalDateCount; eventDateIndex ++) {
                                            product.conditional.eventDateId.push({
                                                id: ''
                                            })
                                        }
                                    } else {
                                        product.verbal = ''//Core.Definition.getDefinition('Vous avez accès à tous les événements')
                                    }
                                }
                            }

                            if (Core.Product.participantModeIsEnabled(product)) {
                                product.participant = {
                                    firstname: '',
                                    lastname: '',
                                    birthdate: '',
                                    urgencyPhone: '',
                                    urgencyContact: '',
                                    teamId: '',
                                    participantCategoryId: '',
                                    tshirtSize: '',
                                    tshirtCustomName: '',
                                    insuranceNumber: '',
                                    teamTitle: ''
                                }
                            }

                            products.push(product)
                        }
                    }
                }
                return products
            }
        },
        mounted() {
            Core.Session.Cart.retrieve()
            let productIds = Core.Array.extractAllByKey(Core.Session.Cart.products, 'id')
            this.$refs.requestOptions.addArg('productIds', productIds)
            this.$refs.requestOptions.request()
        },
        data: function () {
            return {
                Core: window.Core,
                dataProducts: [],
                dataFormTemplates: [],
                dataEventDates: [],
                dataParticipants: [],
                dataSelectOptions: {
                    conditionalSeasonId: [],
                    conditionalLeagueId: [],
                    conditionalDistrictId: [],
                    teamId: [],
                    participantCategoryId: [],
                    tshirtSize: []
                },
                dataProductIndex: '',
                dataEventDateIndex: '',
                dataAlertMessage: false,
                dataVerbal: '',
                dataDisplayNewTeam: false,
                Vue: Vue
            }
        },
        methods: {
            productHasFormTemplate(product) {
                for(let formTemplate in this.dataFormTemplates) {
                    formTemplate = this.dataFormTemplates[formTemplate]
                    if (formTemplate.productId == product.id) {
                        return true
                    }
                }
            },
            getParticipantCategoryOptions(product) {
                let options = []
                product.participantCategoryId = Core.Value.encode(product.participantCategoryId, Core.Value.typeMultiSelect)
                if (Array.isArray(product.participantCategoryId)&&product.participantCategoryId.length > 0) {
                    for(let participantCategoryOption in this.dataSelectOptions.participantCategoryId) {
                        participantCategoryOption = this.dataSelectOptions.participantCategoryId[participantCategoryOption]
                        for(let participantCategoryId in product.participantCategoryId) {
                            participantCategoryId = product.participantCategoryId[participantCategoryId]
                            if (participantCategoryId===participantCategoryOption.value) {
                                options.push(participantCategoryOption)
                            }
                        }
                    }
                } else {
                    options = this.dataSelectOptions.participantCategoryId
                }
                return options
            },
            getTshirtSizeOptions(product) {
                let options = []
                product.tshirtSize = Core.Value.encode(product.tshirtSize, Core.Value.typeMultiSelect)
                if (Array.isArray(product.tshirtSize)&&product.tshirtSize.length > 0) {
                    for(let tshirtSizeOption in this.dataSelectOptions.tshirtSize) {
                        tshirtSizeOption = this.dataSelectOptions.tshirtSize[tshirtSizeOption]
                        for(let tshirtSize in product.tshirtSize) {
                            tshirtSize = product.tshirtSize[tshirtSize]
                            if (tshirtSize===tshirtSizeOption.value) {
                                options.push(tshirtSizeOption)
                            }
                        }
                    }
                } else {
                    options = this.dataSelectOptions.tshirtSize
                }
                return options
            },
            getTeamOptions(product) {
                let options = []
                product.teamId = Core.Value.encode(product.teamId, Core.Value.typeMultiSelect)
                if (Array.isArray(product.teamId)&&product.teamId.length > 0) {
                    for(let teamIdOption in this.dataSelectOptions.teamId) {
                        teamIdOption = this.dataSelectOptions.teamId[teamIdOption]
                        for(let teamId in product.teamId) {
                            teamId = product.teamId[teamId]
                            if (teamId===teamIdOption.value) {
                                options.push(teamIdOption)
                            }
                        }
                    }
                } else {
                    options = Core.Array.newArray(this.dataSelectOptions.teamId)
                }

                if (product.teamCreationIsEnabled) {
                    options.unshift({
                        label: Core.Definition.getDefinition('Nouvelle équipe'),
                        value: 'new'
                    })
                }
                if (product.teamlessIsEnabled) {
                    options.unshift({
                        label: Core.Definition.getDefinition('Sans équipe'),
                        value: ''
                    })
                }
                return options
            },
            filterCompleted(product) {
                if (Core.Value.encode(product.conditionalForceSeasonId, Core.Value.typeCheckbox)) {
                    if (!Core.Validation.isId(Core.Value.decode(product.conditional.seasonId, Core.Value.typeSelect))) {
                        return false
                    }
                }
                if (Core.Value.encode(product.conditionalForceLeagueId, Core.Value.typeCheckbox)) {
                    if (!Core.Validation.isId(Core.Value.decode(product.conditional.leagueId, Core.Value.typeSelect))) {
                        return false
                    }
                }
                if (Core.Value.encode(product.conditionalForceDistrictId, Core.Value.typeCheckbox)) {
                    if (!Core.Validation.isId(Core.Value.decode(product.conditional.districtId, Core.Value.typeSelect))) {
                        return false
                    }
                }
                return true
            },
            filterSeasonId(product) {
                let filter = []

                let conditionalDateConditionals = Core.Value.encode(product.conditionalDateConditionals, Core.Value.typeMultiSelect)

                if (conditionalDateConditionals.includes('season') && product.conditionalForceSeasonId) {
                    filter = Core.Value.decode(product.conditional.seasonId, Core.Value.typeSelect)
                } else {
                    if (product.conditionalDateConditionals && product.conditionalSeasonId !== '') {
                        filter = Core.Value.decode(product.conditionalSeasonId, Core.Value.typeMultiSelect)
                    }
                }
                return filter
            },
            filterLeagueId(product) {
                let filter = []

                let conditionalDateConditionals = Core.Value.encode(product.conditionalDateConditionals, Core.Value.typeMultiSelect)

                if (conditionalDateConditionals.includes('league') && product.conditionalForceLeagueId) {
                    filter = Core.Value.decode(product.conditional.leagueId, Core.Value.typeSelect)
                } else {
                    if (product.conditionalDateConditionals && product.conditionalLeagueId !== '') {
                        filter = Core.Value.decode(product.conditionalLeagueId, Core.Value.typeMultiSelect)
                    }
                }
                return filter
            },
            filterDistrictId(product) {
                let filter = []

                let conditionalDateConditionals = Core.Value.encode(product.conditionalDateConditionals, Core.Value.typeMultiSelect)

                if (conditionalDateConditionals.includes('district') && product.conditionalForceDistrictId) {
                    filter = Core.Value.decode(product.conditional.districtId, Core.Value.typeSelect)
                } else {
                    if (product.conditionalDateConditionals && product.conditionalDistrictId !== '') {
                        filter = Core.Value.decode(product.conditionalDistrictId, Core.Value.typeMultiSelect)
                    }
                }
                return filter
            },
            onContinueShoppingClick() {
                switch(this.productsRedirectType) {
                    case 'router':
                        let productsRedirectUrl = this.productsRedirectUrl
                        if (productsRedirectUrl === '') {
                            productsRedirectUrl = Core.Definition.getDefinition('/commerce/boutique')
                        }
                        this.$router.push(productsRedirectUrl)
                        break
                    case 'url':
                        if (this.productsRedirectUrl!=='') {
                            window.open(this.productsRedirectUrl);
                        }
                        break
                }
            },
            onCheckoutClick() {

                this.dataAlertMessage = false
                for(let productIndex in this.dataProducts) {
                    let product = this.dataProducts[productIndex]

                    if(product.conditional !== undefined && product.conditional.eventDateId !== undefined && Array.isArray(product.conditional.eventDateId)) {
                        for(let eventDate in product.conditional.eventDateId) {
                            eventDate = product.conditional.eventDateId[eventDate]
                            if (!Core.Validation.isId(eventDate.id)) {
                                this.dataAlertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez sélectionner un événement pour le produit {0} #{1}'), product.title, productIndex + 1)
                                return false
                            }
                        }
                    }

                    if (product.participant !== undefined) {
                        if (product.participant.firstname === '') {
                            this.dataAlertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez entrer un prénom pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
                            return false
                        }
                        if (product.participant.lastname === '') {
                            this.dataAlertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez entrer un nom de famille pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
                            return false
                        }
                        if (product.participant.birthdate === '') {
                            this.dataAlertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez entrer une date de naissance pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
                            return false
                        }
                        if (product.participant.insuranceNumber === '') {
                            this.dataAlertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez entrer un numéro d\'assurance maladie pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
                        }
                        if (product.participant.urgencyContact === '') {
                            this.dataAlertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez entrer un contact d\'urgence pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
                            return false
                        }
                        if (product.participant.urgencyPhone === '') {
                            this.dataAlertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez entrer un numéro d\'urgence pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
                            return false
                        }
                        if (Core.Value.encode(product.teamCreationIsEnabled, 'checkbox')) {
                            if (Core.Value.decode(product.participant.teamId, 'select') === 'new' && product.participant.teamTitle === '') {
                                this.dataAlertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez entrer le nom de la nouvelle équipe pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
                                return false
                            }
                        }
                        if (Core.Value.encode(product.participantCategoryIsEnabled, 'checkbox')) {
                            if (Core.Value.decode(product.participant.participantCategoryId, 'select') === '') {
                                this.dataAlertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez sélectionner une catégorie pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
                                return false
                            }
                        }
                        if (Core.Value.encode(product.tshirtSizeIsEnabled, 'checkbox')) {
                            if (Core.Value.decode(product.participant.tshirtSize, 'select') === '') {
                                this.dataAlertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez sélectionner une taille pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
                                return false
                            }
                        }
                    }
                }

                let forms = []
                if(this.dataFormTemplates.length > 0) {
                    for(let formTemplate in this.dataFormTemplates) {
                        formTemplate = this.dataFormTemplates[formTemplate]
                        if (this.$refs['integratedForm' + formTemplate.formTemplateId]!==undefined && this.$refs['integratedForm' + formTemplate.formTemplateId][0]!==undefined) {
                            if (!this.$refs['integratedForm' + formTemplate.formTemplateId][0].validate()) {
                                this.dataAlertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez compléter les champs requis du formulaire'))
                                return false
                            } else {
                                forms.push({
                                    formTemplateId: formTemplate.formTemplateId,
                                    productType: formTemplate.productType,
                                    productId: formTemplate.productId,
                                    values: this.$refs['integratedForm' + formTemplate.formTemplateId][0].getValues()
                                })
                            }
                        }
                    }
                }

                Core.Session.setValue('cartOptions', JSON.stringify({
                    products: this.dataProducts,
                    forms: forms
                }))

                switch(this.checkoutRedirectType) {
                    case 'router':
                        let checkoutRedirectUrl = this.checkoutRedirectUrl
                        if (checkoutRedirectUrl === '') {
                            checkoutRedirectUrl = Core.Definition.getDefinition('/commerce/boutique/confirmation')
                        }
                        this.$router.push(checkoutRedirectUrl)
                        break
                    case 'url':
                        if (this.checkoutRedirectUrl!=='') {
                            window.location.href = this.checkoutRedirectUrl
                        }
                        break
                }
            },
            onSelectEventDateClick(productIndex, eventDateIndex) {
                this.dataProductIndex = productIndex
                this.dataEventDateIndex = eventDateIndex
                if (this.$refs['modalInstanceSelectorEventDate' + productIndex] !== undefined) {
                    this.$refs['modalInstanceSelectorEventDate' + productIndex][0].open = true
                }
            },
            onSelectParticipantClick(productIndex) {
                this.dataProductIndex = productIndex
                if (this.$refs['modalInstanceSelectorParticipant' + productIndex] !== undefined) {
                    this.$refs['modalInstanceSelectorParticipant' + productIndex][0].open = true
                }
            },
            onRequestSuccess(data) {
                if (data.selectOptions !== undefined) {
                    if (data.selectOptions.conditionalSeasonId !== undefined) {
                        this.dataSelectOptions.conditionalSeasonId = data.selectOptions.conditionalSeasonId
                    }
                    if (data.selectOptions.conditionalLeagueId !== undefined) {
                        this.dataSelectOptions.conditionalLeagueId = data.selectOptions.conditionalLeagueId
                    }
                    if (data.selectOptions.conditionalDistrictId !== undefined) {
                        this.dataSelectOptions.conditionalDistrictId = data.selectOptions.conditionalDistrictId
                    }
                    if (data.selectOptions.teamId !== undefined) {
                        this.dataSelectOptions.teamId = data.selectOptions.teamId
                    }
                    if (data.selectOptions.participantCategoryId !== undefined) {
                        this.dataSelectOptions.participantCategoryId = data.selectOptions.participantCategoryId
                    }
                    if (data.selectOptions.tshirtSize !== undefined) {
                        this.dataSelectOptions.tshirtSize = data.selectOptions.tshirtSize
                    }
                }
                if (data.formTemplates !== undefined) {
                    this.dataFormTemplates = data.formTemplates
                }
                this.dataProducts = this.products
            },
            onAddEventDate(row, data) {
                this.dataProducts[this.dataProductIndex].conditional.eventDateId[this.dataEventDateIndex] = row
                this.$forceUpdate()
            },
            onAddParticipant(row, data) {
                let participant = row

                participant.tshirtSize = Core.Select.select(participant.tshirtSize, this.dataSelectOptions.tshirtSize)
                participant.teamId = Core.Select.select(participant.teamId, this.dataSelectOptions.teamId)
                participant.participantCategoryId = Core.Select.select(participant.participantCategoryId, this.dataSelectOptions.participantCategoryId)

                this.dataProducts[this.dataProductIndex].participant = participant
                this.$forceUpdate()
            },
            onSelectTeam(productIndex) {
                if (this.dataProducts[productIndex] !== undefined) {
                    if (this.dataProducts[productIndex].participant !== undefined) {
                        if (this.dataProducts[productIndex].participant.teamId !== undefined) {
                            if (Core.Select.value(this.dataProducts[productIndex].participant.teamId) === 'new') {
                                this.$refs['newTeam' + productIndex][0].isVisible = true
                                return
                            }
                        }
                    }
                }
                this.$refs['newTeam' + productIndex][0].isVisible = false
            }
        }
    }
</script>
